// TODO : Import this file to your from that you want to validate all form not empty
// TODO : Read it. If you not understand the code
// TODO : Ask me if you have any question - The Journey Dev

/*-------------------------------------------------------------------
|  🐼 Function isFormInvalid
|
|  🐯 Purpose: CHECKS IF FORM IS VALID OR NOT
|
|  🐸 Returns: BOOLEAN
|
|  🦄 Note: This function is used in the form validation process. By first loop will check any field if some field is a object,
|          then it will repeat process by call itself (recursive function) until the field is not a object.
|          If the field is not a object, then it will check if the field is empty or not.
|          If the field is empty, then it will return true, otherwise false.
|
|  🐸 Additional Note: I have to create skipField to avoid an error if you want to skip some field
*-------------------------------------------------------------------*/

/*-------------------------------------------------------------------
|  🦄 For example, if we have a form with the following fields:
|  {
|    name: "John Doe",
|    age: 25,
|    address: {
|      street: "123 Main St",
|      city: "New York",
|      state: "NY",
|      zip: 10001
|    }
|  }
|
|  If the user fills out the form like this:
|  {
|    name: "John Doe",
|    age: 25,
|    address: {
|      street: "",
|      city: "New York",
|      state: "NY",
|      zip: 10001
|    }
|  }
|
|  The process will be like this:
|       1. The function will check the name field, which is not empty.
|       2. The function will check the age field, which is not empty.
|       3. The function will check the address field, which is an object.
|  //*  4. The function will call itself and repeat the process because address is an object.
|       5. The function will check the street field, which is empty.
|       6. The function will return true because the street field is empty.
*-------------------------------------------------------------------*/

export const isFormInvalid = (err: any) => {
  console.log("err: ", Object.keys(err).length);
  if (Object.keys(err).length > 0) return true;
  return false;
};

// Utility function to check if any field is not filled
export const isFormNotComplete = (obj: any) => {
  if (!isValid(obj)) {
    console.log("form is not valid: ", obj);
    return true;
  }
  let count = 0;
  let errors = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && skipFields(key) === false) {
      const value = obj[key];
      if (typeof value === "object" && value !== null) {
        if (isFormNotComplete(value)) {
          count++;
        }
      } else if (!isValid(value)) {
        const errorMsg = makeErrorMsg(key, value);
        errors.push(errorMsg);
        count++;
      }
    }
  }
  if (count > 0) {
    // console.log("form not complete: ", errors);
    return true;
  }
  return false;
};

// Utility function to check if any field is not error
export const isFormNotError = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && skipFields(key) === false) {
      const value = obj[key];
      if (typeof value === "object" && value !== null) {
        if (isFormNotComplete(value)) {
          return true;
        }
      } else if (value !== "") {
        // makeErrorMsg(key, value);
        return true;
      }
    }
  }
  return false;
};

// function skip specific fields
export const skipFields = (key: any) => {
  if (
    key === "middle_name" ||
    key === "passport_no" ||
    key === "identifier" ||
    key === "remark" ||
    key === "street" ||
    key === "village_no" ||
    key === "alley"
  ) {
    return true;
  }
  return false;
};

const makeErrorMsg = (key: string, value: any) => {
  let msg = value;
  if (value === "") {
    msg = "empty string";
  }
  // make error message
  const errorMsg = {
    [key]: msg,
  };
  return errorMsg;
  console.log("key:", key, "value:", msg);
};

const isValid = (value: any): boolean => {
  return value !== null && value !== undefined && value !== "" && value !== 0;
};
